import React from 'react';
import { CheckCircleIcon, HomeIcon, UserGroupIcon, OfficeBuildingIcon, CakeIcon } from '@heroicons/react/solid';
import ConfettiStarsButton from '../components/ConfettiButton';
import SEO from '../components/SEO';

const Services = () => {
  const servicesList = [
    {
      title: "Nettoyage de Restaurants",
      description: "Service complet pour cuisines professionnelles et salles de restaurant",
      features: [
        "Nettoyage des équipements de cuisine",
        "Désinfection des surfaces",
        "Nettoyage des hottes et filtres",
        "Entretien des sols et murs",
        "Respect des normes HACCP"
      ],
      icon: <CakeIcon className="h-6 w-6 text-blue-600" />
    },
    {
      title: "Entretien d'Hôtels",
      description: "Solutions adaptées aux établissements hôteliers",
      features: [
        "Nettoyage des espaces communs",
        "Entretien des salles de réunion",
        "Nettoyage des vitres et façades",
        "Service de blanchisserie professionnelle",
        "Désinfection régulière"
      ],
      icon: <HomeIcon className="h-6 w-6 text-blue-600" />
    },
    {
      title: "Nettoyage de Bureaux",
      description: "Services réguliers pour espaces professionnels",
      features: [
        "Nettoyage quotidien des bureaux",
        "Entretien des sanitaires",
        "Nettoyage des vitres",
        "Désinfection des points de contact",
        "Gestion des déchets"
      ],
      icon: <OfficeBuildingIcon className="h-6 w-6 text-blue-600" />
    },
    {
      title: "Service à Occasion",
      description: "Interventions à la demande selon vos besoins",
      features: [
        "Devis rapide",
        "Intervention sous 48h",
        "Sans engagement",
        "Adaptable à vos besoins"
      ],
      icon: <UserGroupIcon className="h-6 w-6 text-blue-600" />
    },
    {
      title: "Nettoyage Post-Chantier",
      description: "Remise en état après travaux de construction ou rénovation",
      features: [
        "Évacuation des débris de chantier",
        "Nettoyage en profondeur des surfaces",
        "Dépoussiérage complet",
        "Nettoyage des vitres et menuiseries",
        "Traitement des sols"
      ],
      icon: <CheckCircleIcon className="h-6 w-6 text-blue-600" />
    }
  ];

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <SEO
        title="Services de Nettoyage | E-omi Services"
        description="Nettoyage de restaurants, hôtels, bureaux, locaux commerciaux et post-chantier en Île-de-France. Qualité professionnelle et réactivité."
        path="/services"
      />
      {/* Hero Section */}
      <div className="bg-blue-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-6">
            Nos Services de Nettoyage
          </h1>
          <p className="text-lg sm:text-xl text-center max-w-3xl mx-auto text-blue-100">
            Des solutions professionnelles adaptées à tous vos besoins de nettoyage
          </p>
        </div>
      </div>

      {/* Services Sections */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8 text-center">
          Nos Types de Services
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {servicesList.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {service.icon}
                <h4 className="text-lg font-bold text-gray-800 ml-2">{service.title}</h4>
              </div>
              <p className="text-gray-600 mb-2">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <ConfettiStarsButton to="/contact">
            🎉 Demander un Devis Gratuit
          </ConfettiStarsButton>
        </div>
      </div>
    </div>
  );
};

export default Services;